export interface ShareIframeProps {
  url: string
}

export function ShareIframe(props: ShareIframeProps) {
  const divStyle = {
    left: 0,
    width: '100%',
    height: 0,
    position: 'relative',
    paddingBottom: '100%'
  } as const
  const iframeStyle = {
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    position: 'absolute',
    border: 0
  } as const

  const src = `${props.url}?embed=true`

  return (
    <div style={divStyle}>
      <iframe
        src={src}
        style={iframeStyle}
        title='Mote'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      ></iframe>
    </div>
  )
}
